module.exports = __webpack_public_path__ + "static/media/moschino_zaino.8a859cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/moschino_zaino.png
// module id = 803
// module chunks = 0